<template>
  <div>
    <div class="columns pl-6 pr-6 " :class="bgSeparator">
      <div class="column is-12">
        <h1 class="has-text-centered letterSpacingShort is-size-2-tablet is-size-3-mobile lineHeight2">
          <span :class="titleOneColor" v-if="titleOne">
            {{ titleOne }}
          </span>
          <span :class="titleTwoColor" v-if="titleTwo">
            {{ titleTwo }}
          </span>
          <span :class="titleThreeColor" v-if="titleThree">
            {{ titleThree }}
          </span>
        </h1>
        <div class="is-block m-2" v-if="subtitleOne || subtitleTwo">
          <p
            class="mb-2 mt-4  mx-auto p-2 | has-text-centered letterSpacingShort fontWeight is-size-4"
            :class="subtitleColor"
          >
            {{ subtitleOne }}
            <br>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Separator',
  props: ['titleOne', 'titleOneColor',
          'titleTwo', 'titleTwoColor',
          'titleThree', 'titleThreeColor',
          'subtitleOne', 'subtitleTwo', 'subtitleColor',
          'bgSeparator']
}
</script>

<style>

</style>
